module.exports = __webpack_public_path__ + "assets/img/3022.361fc488.svg";